import axios from "axios";

declare module "axios" {
  export interface AxiosRequestConfig {
    skipRefreshToken?: boolean;
  }
}

const instance = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "/api/" : "",
});

const getCsrfToken = () => {
  const csrfMatch = document.cookie.match(/csrftoken=([^;]+)/);
  return csrfMatch ? csrfMatch[1] : "";
};

instance.interceptors.request.use(function (config) {
  config.headers["X-CSRFToken"] = getCsrfToken();
  return config;
});

instance.interceptors.request.use(
  function (config) {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = "JWT " + accessToken;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Refresh token logic
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    if (originalRequest.skipRefreshToken) {
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refreshToken");
      const baseURL = process.env.NODE_ENV === "development" ? "/api" : "";
      return axios
        .post(baseURL + "/accounts/jwt/refresh/", {
          refresh: refreshToken,
        })
        .then((res) => {
          localStorage.setItem("accessToken", res.data.access);
          originalRequest.headers["Authorization"] = "JWT " + res.data.access;
          return instance(originalRequest);
        })
        .catch((error) => {
          console.error("Refresh token failed", error);
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          window.location.href = "/prijava";
          return Promise.reject(error);
        });
    }

    return Promise.reject(error);
  },
);

export default instance;
